import BD_Question from "@bd-components/bd-question";

export class QuestionBlank extends BD_Question {
  constructor(...args) {
    super(...args);

    this.elms = {};
  }

  getEvents() {
    return [];
  }

  onCheck() {}

  getAnswer() {}
}
